<script setup>
defineProps({
  alt: String,
  url: String,
  video: String,
  poster: String,
  height: Number,
  hexagon: Boolean,
  classes: String,
})

function handleClick(e) {
  e.preventDefault()
}
</script>

<template>
  <div
    class="bg-hero absolute inset-0 z-[-10] min-h-screen"
    :class="{ 'overflow-hidden': hexagon }" @contextmenu.prevent="handleClick"
  >
    <div class="absolute inset-0 min-h-screen w-full opacity-80 lg:relative">
      <div class="absolute inset-0 z-[3] min-h-screen w-full bg-primary opacity-40 mix-blend-difference" />
      <div class="absolute inset-0 z-[2] min-h-screen w-full bg-primary opacity-80 mix-blend-screen" />
      <div class="absolute inset-0 z-[1] min-h-screen w-full bg-primary/20 mix-blend-color" />
      <nuxt-img v-if="url" :class="[{ 'scale-110': hexagon }, classes]" width="1366" height="574" :style="height ? { height: `${height}px` } : undefined" loading="eager" fetchpriority="high" sizes="lg:1366px, md:1000px, sm:650px, 100vw" :alt="alt" class="hero-image absolute inset-0 z-[1] min-h-screen w-full object-cover object-center opacity-80" :src="url" />
      <video
        v-else
        width="100%" height="100%" fetchpriority="high"
        class="min-h-screen w-full overflow-hidden object-cover object-center transition-shadow duration-150 ease-out" :poster="poster" autoplay loop muted playsinline preload="metadata"
      >
        <source :src="video" type="video/mp4">
      </video>
    </div>
  </div>
  <div class="absolute inset-0 z-[-11] min-h-screen w-full bg-primary" />
</template>
